import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { getSurveyPreview } from "../../Utils/adminFunctions";
import { ToastContainer, toast } from "react-toastify";

let AdminConsentView = () => {
  const { surveyID } = useParams();
  const [consent, setConsent] = useState("");

  useEffect(() => {
    async function fetchAPI1() {
      const response = await getSurveyPreview(surveyID);
      if (response.status == "success") {
        setConsent(response.getConsent);
      } else {
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, []);

  return (
    <div>
      <ToastContainer></ToastContainer>
      <div className="container-fluid custom-container-fluid-background-survey">
        <div className="survey-header">
          <div className=" fade show" id="modal-default" arial-modal="true">
            <div className="modal-dialog custom-modal-consent">
              <div className="modal-content">
                <div className="modal-body">
                  <h5>
                    <b>Consent</b>
                  </h5>
                  <br></br>
                  <p>{consent}</p>
                </div>
                <div className="modal-footer">
                  <Link to="" className="btn custom-btn-primary">
                    Agree
                  </Link>
                  <button type="button" className="btn btn-sm btn-dark">
                    Disagree
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminConsentView;
